



































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import appService from "@/services/appService";
import BlurredTenant from '@/components/BlurredTenant.vue';

export default Vue.extend({
  components: { BlurredTenant },
  data() {
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      self: this,
      chargingStation: null,
      selectedTenant: null,
      selectedTenantId: null,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "startTime",
          "sort-desc": true,
          "class": "sessions-table",
          "item-class": (item) => {
            // Add null check for item
            if (!item) { return ''; }
            
            // Check if item is smart socket or charging station
            if (item.deviceType === 'smartsocket') {
              // Smart socket session - check if still running
              if (!item.stopTime) {
                return 'smart-socket-row-blue';
              } else {
                return 'smart-socket-row-yellow';
              }
            } else {
              // Charging session - check OCPI data
              if (item.ocpi && item.ocpiData && item.ocpiData !== null && item.ocpiData !== '' && item.ocpiData !== undefined) {
                return 'charging-session-row-blue';
              } else if (item.ocpi && (item.ocpiData === null || item.ocpiData === '' || item.ocpiData === undefined)) {
                return 'charging-session-row-yellow';
              }
            }
            
            return '';
          },
        },
        content: {
          name: "Sessions",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Partner / Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const filters = [
                          {
                            key: "_id",
                            operator: "equal_to",
                            value,
                          },
                        ];

                        // If user is cpoGroup, filter by cpoGroupId
                        if (userManager.checkRole(["cpoGroup"], true)) {
                          const userInfo = userManager.getUserInfo();
                          if (userInfo?.cpoGroupId) {
                            filters.push({
                              key: "cpoGroupId",
                              operator: "equal_to",
                              value: userInfo.cpoGroupId,
                            });
                          }
                        }

                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters,
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              userId: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  required: true,
                  "item-value": "_id",
                  "item-text": "email",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "email",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              retailerId: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Retailer",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("retailers", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              chargerVendorId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Charger Vendor",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("chargerVendors", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              "chargingStationSnapshot.serialNumber": {
                attrs: {
                  label: "Serial Number",
                },
                rules: {
                  match: {},
                },
              },
              "chargingStationSnapshot.uniqueId": {
                attrs: {
                  label: "Device ID",
                },
                rules: {
                  match: {},
                },
              },
              connectorId: {
                attrs: {
                  label: "Connector ID",
                },
                rules: {
                  equal_to: {},
                },
              },
              "details._id": {
                type: "integer",
                attrs: {
                  label: "Transaction ID",
                },
                rules: {
                  equal_to: {},
                },
              },
              ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                transactionID: {
                  type: "text",
                  attrs: {
                    label: "Invoice Code",
                  },
                  rules: {
                    includes: {},
                  },
                },
              }),
              "details.tagID": {
                attrs: {
                  label: "ID Tag",
                },
                rules: {
                  match: {},
                },
              },
              startTime: {
                type: "XTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Start Time (From)",
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Start Time (To)",
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            "details._id": {
              text: "Transaction ID",
              options: {
                subProp: "details._id",
                sortBy: "details._id",
              },
            },
            startTime: {
              text: "Start Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            stopTime: {
              text: "End Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            uniqueId: {
              text: "Device",
              options: {
                subProp: "chargingStationSnapshot.uniqueId",
                sortBy: "chargingStationSnapshot.uniqueId",
              },
            },
            deviceType: {
              text: "Device Type",
              sortable: true,
              options: {
                subProp: "deviceType",
                preTransform(value) {
                  if (value == null) { return 'Charging Station'; }
                  return value === 'smartsocket' ? 'Smart Socket' : 'Charging Station';
                },
                filter: "text",
                sortBy: "deviceType",
              },
            },
            user: {
              text: "User",
              options: {
                subProp: "userSnapshot.email",
                label: true,
                sortBy: "userId",
              },
            },
            rfid: {
              text: "RFID",
              options: {
                subProp: "tagSnapshot.value"
              },
            },
            carName: {
              text: "Car",
              options: {
                subProp: "carSnapshot.name"
              },
            },
            licensePlate: {
              text: "License Plate",
              options: {
                subProp: "carSnapshot.licensePlate"
              },
            },
            vin: {
              text: "Vin",
              options: {
                subProp: "carSnapshot.vin"
              },
            },
            pointOrigin: {
              text: "Before Discount",
              options: {
                preTransform(value) {
                  if (value == null) { return '0'; }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            point: {
              text: "After Discount",
              options: {
                preTransform(value) {
                  if (value == null) { return '0'; }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            pointPromotion: {
              text: "Use Promotion",
              options: {
                preTransform(value) {
                  if (value == null || value === 0) { return '0' }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
              transactionID: {
                text: "Invoice Code",
                options: {
                  subProp: "transactionID",
                  sortBy: "transactionID",
                },
              },
            }),
            retailer: {
              text: "Retailer",
              options: {
                subProp: "retailerSnapshot.name",
                label: true,
                sortBy: "retailerId",
              },
            },
            chargerVendor: {
              text: "Charger Vendor",
              options: {
                subProp: "chargerVendorSnapshot.name",
                label: true,
                sortBy: "chargerVendorId",
              },
            },
            serialNumber: {
              text: "Serial Number",
              options: {
                subProp: "chargingStationSnapshot.serialNumber",
                sortBy: "chargingStationSnapshot.serialNumber",
              },
            },
            connectorId: {
              text: "Connector ID",
              sortable: true,
            },
            duration: {
              text: "Duration (minutes)",
              sortable: true,
              options: {
                subProp: "details.stop.totalDurationSecs",
                preTransform(value) {
                  if (value == null) { return 0; }
                  return (value || 0) * 1000;
                },
                filter: "number",
                sortBy: "details.stop.totalDurationSecs",
              },
            },
            meterStart: {
              text: "Meter Start (Wh)"
            },
            meterStop: {
              text: "Meter Stop (Wh)",
              options: {
                subProp: "details.stop.meterStop",
                preTransform(value) {
                  if (value == null) { return 0; }
                  return (value || 0);
                },
                sortBy: "details.stop.meterStop",
                filter: "number",
              },
            },
            energyDelivered: {
              text: "Energy Delivered (kWh)",
              sortable: true,
              options: {
                subProp: "details.stop.totalConsumptionWh",
                preTransform(value) {
                  if (value == null) { return 0; }
                  return (value || 0) / 1000;
                },
                filter: "number",
                sortBy: "details.stop.totalConsumptionWh",
              },
            },
            "soc": {
              text: "SoC",
            },
            "voltage": {
              text: "Voltage",
            },
            "powerActiveImport": {
              text: "Power.Active.Import (W)",
            },
            "currentImport": {
              text: "Current.Import (A)",
            },
            ocpi: {
              text: "OCPI",
              sortable: true,
              options: {
                preTransform(value) {
                  if (value == null) { return "No"; }
                  return value ? "Yes" : "No";
                },
                filter: "text",
                sortBy: "ocpi",
              },
            },
            ocpiData: {
              text: "OCPI Data",
              sortable: true,
              options: {
                preTransform(value) {
                  if (value == null) { return "No Data"; }
                  return value && value !== null && value !== '' ? "Has Data" : "No Data";
                },
                filter: "text",
                sortBy: "ocpiData",
              },
            },
            tenant: userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
          },
          multiSelectActionButtons: {
            export: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
              content: {
                text: "Export selected",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("chargingSessions", `@/export`, {
                    payload: JSON.stringify({
                      filters: [
                        {
                          key: "_id",
                          operator: "in",
                          value: dataTable.model.value.map((item) => item._id),
                        },
                      ],
                      limit: -1,
                      extraParams: {
                        currentTimeZoneOffset: new Date().getTimezoneOffset() * -1 * 60 * 1000,
                      },
                    }),
                  });
                },
              },
            },
          },
          topActionButtons: {
            export: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
              content: {
                text: "Export all",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("chargingSessions", `@/export`, dataTable.getFindAllOptions());
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            const { $route } = this.context();

            // Debug: Log route params for debugging
            console.log('Sessions findAllOptionsFilter - route query:', $route.query);

            // Handle tenantId priority: route query > table_options > activeTenant
            let tenantIdToUse = null;

            // Check route query first (highest priority)
            if ($route.query.tenantId) {
              tenantIdToUse = $route.query.tenantId;
            }

            // Check table_options for tenantId if no route tenantId
            if (!tenantIdToUse && $route.query.table_options) {
              try {
                let tableOptionsStr = $route.query.table_options;

                // Handle base64 encoding properly
                if (tableOptionsStr.startsWith('eyJ')) {
                  tableOptionsStr = atob(tableOptionsStr);
                } else {
                  tableOptionsStr = decodeURIComponent(tableOptionsStr);
                }

                const tableOptions = JSON.parse(tableOptionsStr);
                console.log('Sessions - parsed table_options:', tableOptions);
                if (tableOptions.filters) {
                  const tenantFilter = tableOptions.filters.find(f => f.key === 'tenantId');
                  if (tenantFilter && tenantFilter.value) {
                    tenantIdToUse = tenantFilter.value;
                    console.log('Sessions - tenantId from table_options:', tenantIdToUse);
                  }
                }
              } catch (error) {
                console.error('Error parsing table_options for tenantId:', error);
                console.error('table_options value:', $route.query.table_options);
              }
            }

            // Fallback to activeTenant if no tenantId from other sources
            if (!tenantIdToUse) {
              const activeTenant = appService.getActiveTenant();
              if (activeTenant) {
                tenantIdToUse = activeTenant._id;
              }
            }

            // Add single tenantId filter if we have one and it's not already in filters
            if (tenantIdToUse) {
              console.log('Sessions - Final tenantId to use:', tenantIdToUse);

              // Check if tenantId filter already exists
              const existingTenantFilter = options.filters.find(f => f.key === 'tenantId');
              if (!existingTenantFilter) {
                options.filters.push({
                  key: "tenantId",
                  operator: "equal_to",
                  value: tenantIdToUse,
                });
              } else {
                // Update existing filter value
                existingTenantFilter.value = tenantIdToUse;
                existingTenantFilter.operator = "equal_to";
              }

              // Store tenantId for display
              this.selectedTenantId = tenantIdToUse;
            }

            if ($route.query.chargingStationId) {
              options.filters.push({
                key: "chargingStationId",
                operator: "equal_to",
                value: $route.query.chargingStationId,
              });
            }

            // Handle OCPI parameters from URL
            if ($route.query.ocpi !== undefined) {
              console.log('Sessions - Processing OCPI from URL:', $route.query.ocpi);
              const existingOcpiFilter = options.filters.find(f => f.key === 'ocpi');
              const ocpiValue = $route.query.ocpi === 'true';

              if (!existingOcpiFilter) {
                console.log('Sessions - Adding new OCPI filter:', ocpiValue);
                options.filters.push({
                  key: "ocpi",
                  operator: "equal_to",
                  value: ocpiValue,
                });
              } else {
                console.log('Sessions - Updating existing OCPI filter:', ocpiValue);
                existingOcpiFilter.value = ocpiValue;
                existingOcpiFilter.operator = "equal_to";
              }
            } else {
              console.log('Sessions - No OCPI parameter in URL');
            }

            // Handle OCPI Data parameters from URL
            if ($route.query.ocpiData !== undefined) {
              console.log('Sessions - Processing OCPI Data from URL:', $route.query.ocpiData);
              const existingOcpiDataFilter = options.filters.find(f => f.key === 'ocpiData');
              let operator, value;

              if ($route.query.ocpiData === 'null') {
                operator = 'equal_to';
                value = null;
              } else if ($route.query.ocpiData === 'not_null') {
                operator = 'not_equal_to';
                value = null;
              }

              if (operator) {
                if (!existingOcpiDataFilter) {
                  console.log('Sessions - Adding new OCPI Data filter:', operator, value);
                  options.filters.push({
                    key: "ocpiData",
                    operator: operator,
                    value: value,
                  });
                } else {
                  console.log('Sessions - Updating existing OCPI Data filter:', operator, value);
                  existingOcpiDataFilter.operator = operator;
                  existingOcpiDataFilter.value = value;
                }
              } else {
                console.log('Sessions - Invalid OCPI Data value:', $route.query.ocpiData);
              }
            } else {
              console.log('Sessions - No OCPI Data parameter in URL');
            }

            // Handle stopTime parameters from URL
            if ($route.query.stopTimeFrom !== undefined) {
              const existingStopTimeFromFilter = options.filters.find(f => f.key === 'stopTime' && f.operator === 'greater_than_or_equal_to');
              const stopTimeFromValue = parseInt($route.query.stopTimeFrom);

              if (!existingStopTimeFromFilter) {
                options.filters.push({
                  key: "stopTime",
                  operator: "greater_than_or_equal_to",
                  value: stopTimeFromValue,
                });
              } else {
                existingStopTimeFromFilter.value = stopTimeFromValue;
              }
            }

            if ($route.query.stopTimeTo !== undefined) {
              const existingStopTimeToFilter = options.filters.find(f => f.key === 'stopTime' && f.operator === 'less_than_or_equal_to');
              const stopTimeToValue = parseInt($route.query.stopTimeTo);

              if (!existingStopTimeToFilter) {
                options.filters.push({
                  key: "stopTime",
                  operator: "less_than_or_equal_to",
                  value: stopTimeToValue,
                });
              } else {
                existingStopTimeToFilter.value = stopTimeToValue;
              }
            }

            // Check if we have table_options from CashbackDetail for other filters (excluding tenantId)
            if ($route.query.table_options) {
              try {
                let tableOptionsStr = $route.query.table_options;

                // Check if it's base64 encoded (starts with eyJ which is base64 for '{"')
                if (tableOptionsStr.startsWith('eyJ')) {
                  // It's base64 encoded, decode it first
                  tableOptionsStr = atob(tableOptionsStr);
                } else {
                  // It's URL encoded, decode it
                  tableOptionsStr = decodeURIComponent(tableOptionsStr);
                }

                const tableOptions = JSON.parse(tableOptionsStr);
                if (tableOptions.filters) {
                  // Merge filters from table_options
                  tableOptions.filters.forEach(filter => {
                    // Check if filter already exists
                    const existingFilter = options.filters.find(f => f.key === filter.key);
                    if (existingFilter) {
                      // Update existing filter
                      existingFilter.operator = filter.operator;
                      existingFilter.value = filter.value;
                    } else {
                      // Add new filter
                      options.filters.push(filter);
                    }
                  });
                }
              } catch (error) {
                console.error('Error parsing table_options in findAllOptionsFilter:', error);
                console.error('table_options value:', $route.query.table_options);
              }
            }

            // No deviceType filter - show both charging sessions and smart socket sessions
            // This will include all sessions regardless of device type

            // Handle OCPI filter
            const ocpiFilter = options.filters.find(f => f.key === 'ocpi');
            if (ocpiFilter && ocpiFilter.value !== undefined) {
              if (ocpiFilter.value === 'true' || ocpiFilter.value === true) {
                ocpiFilter.operator = 'equal_to';
                ocpiFilter.value = true;
              } else if (ocpiFilter.value === 'false' || ocpiFilter.value === false) {
                ocpiFilter.operator = 'equal_to';
                ocpiFilter.value = false;
              }
            } else if (ocpiFilter && ocpiFilter.value === undefined) {
              // Remove filter if no value selected
              options.filters = options.filters.filter(f => f.key !== 'ocpi');
            }

            // Handle OCPI Data filter
            const ocpiDataFilter = options.filters.find(f => f.key === 'ocpiData');
            if (ocpiDataFilter && ocpiDataFilter.value !== undefined) {
              if (ocpiDataFilter.value === 'not_null') {
                ocpiDataFilter.operator = 'not_equal_to';
                ocpiDataFilter.value = null;
              } else if (ocpiDataFilter.value === 'null') {
                ocpiDataFilter.operator = 'equal_to';
                ocpiDataFilter.value = null;
              }
            } else if (ocpiDataFilter && ocpiDataFilter.value === undefined) {
              // Remove filter if no value selected
              options.filters = options.filters.filter(f => f.key !== 'ocpiData');
            }

            options.extraParams.currentTimeZoneOffset = new Date().getTimezoneOffset() * -1 * 60 * 1000;

            // Debug: Log final filters
            console.log('Sessions - Final filters before API call:', options.filters);
            console.log('Sessions - Final filters details:', JSON.stringify(options.filters, null, 2));

            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              // Parse the payload to add any missing filters
              const payload = JSON.parse(options.payload || "{}");
              let filters = payload.filters || [];

              // Try to get route safely
              let $route = null;
              try {
                $route = this.$route || (this.context && this.context().$route);
              } catch (e) {
                // If route is not accessible, skip route-based logic
                console.warn('Cannot access route in findAll:', e);
              }

              // Note: tenantId filter is handled in findAllOptionsFilter to avoid duplicates
              // Only handle other hidden filters here that are not in UI

              // Handle filters from table_options (from CashbackDetail) - excluding tenantId
              if ($route && $route.query && $route.query.table_options) {
                try {
                  let tableOptionsStr = $route.query.table_options;

                  // Check if it's base64 encoded (starts with eyJ which is base64 for '{"')
                  if (tableOptionsStr.startsWith('eyJ')) {
                    // It's base64 encoded, decode it first
                    tableOptionsStr = atob(tableOptionsStr);
                  } else {
                    // It's URL encoded, decode it
                    tableOptionsStr = decodeURIComponent(tableOptionsStr);
                  }

                  const tableOptions = JSON.parse(tableOptionsStr);
                  if (tableOptions.filters) {
                    tableOptions.filters.forEach(filter => {
                      // Add hidden filters if they don't already exist (excluding tenantId)
                      if (['ocpi', 'ocpiData', 'stopTime'].includes(filter.key)) {
                        const existingFilter = filters.find(f => f.key === filter.key);
                        if (!existingFilter) {
                          filters.push(filter);
                        } else {
                          // Update existing filter with new values
                          existingFilter.operator = filter.operator;
                          existingFilter.value = filter.value;
                        }
                      }
                    });
                  }
                } catch (error) {
                  console.error('Error parsing table_options in findAll:', error);
                  console.error('table_options value:', $route.query.table_options);
                }
              }

              // Process OCPI filter (convert string to boolean)
              const ocpiFilter = filters.find(f => f.key === 'ocpi');
              if (ocpiFilter && ocpiFilter.value) {
                if (ocpiFilter.value === 'true') {
                  ocpiFilter.operator = 'equal_to';
                  ocpiFilter.value = true;
                } else if (ocpiFilter.value === 'false') {
                  ocpiFilter.operator = 'equal_to';
                  ocpiFilter.value = false;
                }
              } else if (ocpiFilter && !ocpiFilter.value) {
                // Remove filter if no value selected
                filters = filters.filter(f => f.key !== 'ocpi');
              }

              // Process OCPI Data filter
              const ocpiDataFilter = filters.find(f => f.key === 'ocpiData');
              if (ocpiDataFilter && ocpiDataFilter.value) {
                if (ocpiDataFilter.value === 'not_null') {
                  ocpiDataFilter.operator = 'not_equal_to';
                  ocpiDataFilter.value = null;
                } else if (ocpiDataFilter.value === 'null') {
                  ocpiDataFilter.operator = 'equal_to';
                  ocpiDataFilter.value = null;
                }
              } else if (ocpiDataFilter && !ocpiDataFilter.value) {
                // Remove filter if no value selected
                filters = filters.filter(f => f.key !== 'ocpiData');
              }

              // Update the payload with the modified filters
              options.payload = JSON.stringify({
                ...payload,
                filters,
              });

              const { items, count } = await coreApiClient.call("chargingSessions", "findAll", options);
              return [items, count];
            },
          },
        },
      },
    };
  },
  methods: {
  },
  async created() {
    const $route = this.$route;
    if ($route.query.chargingStationId) {
      const chargingStation = await coreApiClient.call("chargingStations", "findById", {
        id: $route.query.chargingStationId,
      });
      this.chargingStation = chargingStation;
    }

    // Handle tenantId from route query parameter
    if ($route.query.tenantId) {
      this.selectedTenantId = $route.query.tenantId;
    }

    // Get tenant information if we have tenantId from filters or route query
    if (this.selectedTenantId) {
      try {
        const tenant = await coreApiClient.call("tenants", "findById", {
          id: this.selectedTenantId,
        });
        this.selectedTenant = tenant;
      } catch (error) {
        console.error('Error fetching tenant:', error);
      }
    }

    // Also check if we have table_options from CashbackDetail (if no route tenantId)
    if (!this.selectedTenantId && $route.query.table_options) {
      try {
        let tableOptionsStr = $route.query.table_options;

        // Handle base64 encoding properly
        if (tableOptionsStr.startsWith('eyJ')) {
          tableOptionsStr = atob(tableOptionsStr);
        } else {
          tableOptionsStr = decodeURIComponent(tableOptionsStr);
        }

        const tableOptions = JSON.parse(tableOptionsStr);
        if (tableOptions.filters) {
          const tenantFilter = tableOptions.filters.find(f => f.key === 'tenantId');
          if (tenantFilter && tenantFilter.value) {
            this.selectedTenantId = tenantFilter.value;
            try {
              const tenant = await coreApiClient.call("tenants", "findById", {
                id: tenantFilter.value,
              });
              this.selectedTenant = tenant;
            } catch (error) {
              console.error('Error fetching tenant:', error);
            }
          }
        }
      } catch (error) {
        console.error('Error parsing table_options in created():', error);
        console.error('table_options value:', $route.query.table_options);
      }
    }
  },
});
